/* eslint-disable no-undef */
import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

// Initialize Bugsnag
Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY || 'YOUR_BUGSNAG_API_KEY_HERE',
  plugins: [new BugsnagPluginReact(React)],
  enabledReleaseStages: ['production', 'staging', 'development'],
  releaseStage: process.env.ENVIRONMENT || 'development',
  appVersion: process.env.REACT_APP_VERSION || '1.0.0',
  collectUserIp: false,
  enabledBreadcrumbTypes: [
    'navigation',
    'request',
    'process',
    'log',
    'user',
    'state',
    'error',
    'manual',
  ],
  onError: function (event) {
    // Add user context if available
    const userInfo = localStorage.getItem('user');
    if (userInfo) {
      try {
        const user = JSON.parse(userInfo);
        event.setUser(user.id, user.email, user.name);
      } catch (e) {
        // Ignore parsing errors
      }
    }

    // Add additional context
    event.addMetadata('app', {
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    });
  },
});

// Create the error boundary component
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary();

export default Bugsnag;
export { ErrorBoundary };
